import bold from "../default-icons/bold";
import strikethrough from "../default-icons/strikethrough";
import italic from "../default-icons/italic";
export default { bold, strikethrough, italic };
